import { Form, Input } from 'antd';
import Button from '../../components/Button';
import { isValidEmail } from '../../helper/utils';
import { useState } from 'react';
import AuthServices from 'services/AuthServices';
import { toast } from 'sonner';
import { NO_INTERNET } from 'components/messageError';

const ForgotPass = ({ onToggle, onBack, onChangeEmail }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const handleSendOtp = async (values) => {
    const bodyData = {
      email: values.email,
      environment: 'WEB_ADMIN',
    };

    if (values?.errorFields?.length > 0) return;
    else {
      try {
        setLoading(true);
        setDisableSubmit(true);

        const res = await AuthServices.confirmEmail(bodyData);

        if (res.statusCode === 200 || res.statusCode === 201) {
          toast.success('メールの送信に成功しました');
          onToggle();
        }
      } catch (err) {
        toast.error(err?.message || err || NO_INTERNET);
      } finally {
        setLoading(false);
        setDisableSubmit(false);
      }
    }
  };

  const handleSubmit = () => {
    if (loading || disableSubmit) return;

    form
      .validateFields()
      .then((val) => {
        handleSendOtp(val);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    onChangeEmail(value);
  };
  return (
    <>
      <div className="!mb-[40px] 2xl:mb-[60px]">
        <h2
          className="text-welcome"
          style={{ paddingLeft: 0, paddingBottom: 10 }}
        >
          パスワード再設定
        </h2>
        <div>
          <div className="text-title">
            登録しているメールアドレスをご入力ください。
          </div>
          <div className="text-title">
            新しいパスワードを設定するための案内をお送りします。
          </div>
        </div>
      </div>
      <div className="mb-10 2xl:mb-[30px]">
        <Form form={form}>
          <Form.Item
            normalize={(value) => value.replace(/\s+/g, '')}
            style={{ marginBottom: '30px' }}
            rules={[
              {
                required: true,
                message: 'メールアドレスを入力してください',
                validateTrigger: 'onChange',
              },
              {
                pattern: isValidEmail(),
                message: '有効なメールアドレスを入力してください',
                validateTrigger: 'onChange',
              },
            ]}
            name={'email'}
          >
            <Input placeholder="メールアドレス" onChange={handleEmailChange} />
          </Form.Item>
        </Form>
        <Button
          className="btn-login btn-auth-submit !w-full"
          fontWeight="bold"
          onClick={handleSubmit}
          loading={loading}
          type="primary"
        >
          <p style={{ letterSpacing: '0' }}>送信</p>
        </Button>
        <Button
          className="mt-5 2xl:mt-[30px]"
          btnType="auth-back"
          onClick={onBack}
          fontWeight="bold"
        >
          ログイン画面に戻る
        </Button>
      </div>
    </>
  );
};

export default ForgotPass;
